module.exports = __webpack_public_path__ + "img/language.699ee1ae.png";